module.exports = __webpack_public_path__ + "img/knu_main0.d1128ea0.jpg";